<template>
  <board :details="boardInfo" />
</template>

<script>
import Board from 'Board';

export default {
  name: 'PlanBoard',
  components: {
    Board,
  },
  props: {
    mainInfo: {
      type: Array,
      default: () => [],
    },
    secondaryInfo: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    boardInfo() {
      return [...[this.mainInfo], ...[this.secondaryInfo]];
    },
  },
};
</script>

<style lang="scss" scoped></style>
